module.exports = __webpack_public_path__ + "static/media/mosca_valdez_unknown.725f416a.jpg";